import { Pipe, PipeTransform } from '@angular/core';
import { CustomUtils } from '../utils/custom-utils';

@Pipe({
  name: 'instanceNumber',
  standalone: false
})
export class InstanceNumberPipe implements PipeTransform {
  public transform(formName: string, instanceNumber: string): string {
    return CustomUtils.concatFormNameWithNumber(formName, instanceNumber);
  }
}
